import { AxiosInstance } from "@bps/http-client";

import {
  OpsReportDefinition,
  OpsReportInstance,
  ReportDefinitionArgs
} from "./plt-reports-ops-gateway.dtos";
import { IPlatformReportsOpsGateway } from "./plt-reports-ops-gateway.interface";

export class PlatformReportsOpsGateway implements IPlatformReportsOpsGateway {
  constructor(private api: AxiosInstance) {}

  getOpsReportDefinitions = async (
    body?: ReportDefinitionArgs
  ): Promise<OpsReportDefinition[]> => {
    const { data } = await this.api.post("reportDefinitions", body);
    return data;
  };

  getOpsReportInstanceByName = async (
    name: string,
    body: { FieldDeviceId?: string }
  ): Promise<OpsReportInstance> => {
    const { data } = await this.api.post(`reportInstance/name/${name}`, body);
    return data;
  };

  postReportRefresh = async (name: string): Promise<void> => {
    await this.api.post(`refresh/${name}`);
  };
}
